<template>
  <base-button type="submit" class="btn-primary" text="更新" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'UpdateButton',
  components: {
    BaseButton,
  },
}
</script>
